// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#doses .day-break {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  margin: 25px 0;
  color: var(--light-grey-color);
  font-size: 1.8rem;
}

#doses .day-break.first {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/entries/DayBreak.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf","sourcesContent":["#doses .day-break {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 25px 0;\n  color: var(--light-grey-color);\n  font-size: 1.8rem;\n}\n\n#doses .day-break.first {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
